import { strict } from "assert";


export class ClsArmData {
    private classifications: any = null;
    private armaments: any = null;

    constructor(classifications?: any, armaments?: any) {
        if (classifications && armaments) {
            this.fillData(classifications, armaments);
        }
    }

    fillData(classifications: any, armaments: any) {
        this.fillClassifications(classifications);
        this.fillArmaments(armaments);
    }

    fillClassifications(classifications: any) {
        this.classifications = classifications;
    }

    fillArmaments(armaments: any) {
        this.armaments = armaments;
    }

    getAllClsCats(): Array<string> {
        return Object.keys(this.classifications);
    }

    getAllPlatsOfCat(str: string): Array<string> {
        if (this.classifications[str] == undefined) {
            return null;
        }
        else {
            return Object.keys(this.classifications[str]);
        }
    }

    getIndexOfCat(cat: string): number{
        return this.getAllClsCats().indexOf(cat);
    }

    getIndexOfPlt(cat: string, plt: string): number{
        return this.getAllPlatsOfCat(cat).indexOf(plt);
    }
}